module.exports = __webpack_public_path__ + "static/www/img/tencent@3x.f8e324d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerInfo/tencent@3x.png
// module id = 370
// module chunks = 1